import { environmentConfig } from '../../config/environment/environmentConfig'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import DefaultLayout from '../../components/layout/DefaultLayout'
import ForgottenPasswordSendEmailCard from '../../components/app/forgotten-password/send-email-card/ForgottenPasswordSendEmailCard'
import type { NextPage } from 'next'

const ForgottenPasswordPage: NextPage = () => {
    const { t } = useTranslation('forgottenPassword')

    return (
        <DefaultLayout title={t('forgottenPasswordPage.title')}>
            <ForgottenPasswordSendEmailCard/>
        </DefaultLayout>
    )
}

export const getServerSideProps: GetServerSideAndEnvironmentProps<{}> = async ({ locale = 'cs' }) => {
    return {
        props: {
            ...(await serverSideTranslations(locale, ['common', 'forgottenPassword'])),
            environmentConfig
        }
    }
}

export default ForgottenPasswordPage